import React from "react";

const FormHeading = ({ children }: { children: string }) => {
  return <div className="font-semibold my-3">{children}</div>;
};

export default FormHeading;
